import { SearchOutDto, SearchResultsInDto } from '../../../types/search.dto';

export const SEARCH_CONTENT = 'SEARCH_CONTENT';
export const SEARCH_CONTENT_SUCCESS = 'SEARCH_CONTENT_SUCCESS';
export const SEARCH_CONTENT_ERROR = 'SEARCH_CONTENT_ERROR';
export const RESET_SEARCH_CONTENT = 'RESET_SEARCH_CONTENT';

export interface SearchContent {
  type: typeof SEARCH_CONTENT;
  payload: SearchOutDto;
}

export interface SearchContentSuccess {
  type: typeof SEARCH_CONTENT_SUCCESS;
  payload: SearchResultsInDto;
}

export interface SearchContentError {
  type: typeof SEARCH_CONTENT_ERROR;
  payload: string | boolean;
}

export interface ResetSearchContent {
  type: typeof RESET_SEARCH_CONTENT;
  payload: null;
}

export interface State {
  data: SearchResultsInDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | SearchContent
  | SearchContentSuccess
  | SearchContentError
  | ResetSearchContent;
